export const VMSRoutesName = {
  orderList:'/vms/orderList',
  orderDraftList:'/vms/orderList?status=Draft',
  orderApayList:'/vms/orderList?status=Apay',
  orderPickList:'/vms/orderList?status=Pick',
  orderAcceptList:'/vms/orderList?status=Accept',
  orderHistoryList:'/vms/orderList?status=history'
};

export const PushNotificationRoutes = {
  pushNotification: "/push-notification",
};